var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import dayjs from "dayjs";
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { DropDownIconNew } from "../../../../assets/customIcons";
import { useAppSelector } from "../../../../store/hooks";
import { useState } from "react";
import { MailGrayIcon, MarkerPin } from "../../assets/svg";
export var customerDetailsView = [{
        type: FormItemTypes.CardComponent,
        name: "",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                gap: 1,
                elements: [{
                        type: FormItemTypes.Avatar,
                        name: "",
                        columnSize: 0,
                        sx: {
                            height: 40,
                            width: 40
                        }
                    }, {
                        type: FormItemTypes.ContainerItem,
                        name: '',
                        spacing: 0,
                        columnSize: true,
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                spacing: 0,
                                columnSize: 12,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "CustomerName",
                                        value: '-',
                                        columnSize: true,
                                        fontWeight: "medium",
                                        valueGetter: function (formValues, field) {
                                            var customerName = (formValues === null || formValues === void 0 ? void 0 : formValues.CustomerName) || '';
                                            return customerName.length > 25 ? "".concat(customerName.substring(0, 25), "...") : customerName;
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        }
                                    }, {
                                        type: FormItemTypes.Icon,
                                        name: "",
                                        // children: (
                                        // <CustomerCardEditIcon color="secondary" />
                                        // ),
                                        columnSize: 0,
                                        sx: {
                                            cursor: "pointer",
                                            height: "20px",
                                            width: "20px"
                                        }
                                    }]
                            }, {
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                spacing: 0,
                                columnSize: 12,
                                gap: 1,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "CustomerMobileNumber",
                                        value: '-',
                                        columnSize: 0,
                                        fontSize: "sm",
                                        fontWeight: "normal",
                                        color: "secondary.500"
                                    }
                                    // {
                                    //     type: FormItemTypes.Icon,
                                    //     name:'',
                                    //     columnSize: 0,
                                    //     sx:{
                                    //         mt:0.3,
                                    //         fontSize:27
                                    //     },
                                    //     children:<CheckVerified sx={{height:500, width:500}}/>,        
                                    // },
                                    // {
                                    //     type: FormItemTypes.Divider,
                                    //     name: "name",
                                    //     variant: "fullWidth",
                                    //     orientation: "vertical",
                                    //     columnSize: 0,
                                    // },
                                    // {
                                    //     type: FormItemTypes.Typography,
                                    //     name: "CustomerMobileNumber",
                                    //     value: '-',
                                    //     columnSize: true,
                                    //     fontSize: "sm",
                                    //     fontWeight: "normal",
                                    //     color: "secondary.500",
                                    // },
                                ]
                            }]
                    }
                    // {
                    //     type: FormItemTypes.Typography,
                    //     name: "CustomerName",
                    //     value: '-',
                    //     columnSize: true,
                    //     fontWeight: "medium",
                    //     valueGetter: (formValues, field) => {
                    //         const customerName = formValues?.CustomerName || '';
                    //         return customerName.length > 20
                    //             ? `${customerName.substring(0, 20)}...`
                    //             : customerName;
                    //     },
                    //     labelTypographyProps: {
                    //         mb: 0,
                    //         noWrap: true,
                    //         fontWeight: "medium",
                    //         fontSize: "sm",
                    //     }
                    // },
                    // {
                    //     type: FormItemTypes.Typography,
                    //     name: "CustomerMobileNumber",
                    //     value: '-',
                    //     columnSize: 0,
                    //     fontSize: "sm",
                    //     color: "text.secondary",
                    // },
                    // {
                    //     type: FormItemTypes.Icon,
                    //     name:'',
                    //     containerProps:{
                    //         p:0
                    //     },
                    //     children:<CheckVerified sx={{ color: "#0052ff", height: '20px', width: '20px' }}/>,        
                    // }
                ]
            }, {
                type: FormItemTypes.Divider,
                name: "divider",
                variant: "fullWidth",
                columnSize: 12
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: '',
                        columnSize: 12,
                        spacing: 0,
                        gap: 1,
                        containerProps: {
                            p: 1
                        },
                        elements: [{
                                type: FormItemTypes.IconButton,
                                name: "",
                                children: /*#__PURE__*/ React.createElement(MailGrayIcon, {
                                    sx: {
                                        fontSize: 15
                                    }
                                }),
                                columnSize: 0,
                                sx: {
                                    color: "secondary.500",
                                    paddingInline: 0
                                }
                            }, {
                                type: FormItemTypes.Typography,
                                name: "CustomerEmail",
                                columnSize: true,
                                value: '-',
                                color: "secondary",
                                fontSize: "sm",
                                pt: 0.3,
                                fontWeight: "normal"
                            }]
                    }, {
                        type: FormItemTypes.ContainerItem,
                        name: '',
                        columnSize: 12,
                        spacing: 0,
                        gap: 1,
                        containerProps: {
                            p: 1
                        },
                        elements: [{
                                type: FormItemTypes.IconButton,
                                name: "",
                                children: /*#__PURE__*/ React.createElement(MarkerPin, {
                                    sx: {
                                        fontSize: 15
                                    }
                                }),
                                columnSize: 0,
                                sx: {
                                    color: "secondary.500",
                                    paddingInline: 0
                                }
                            }, {
                                type: FormItemTypes.Typography,
                                name: "CustomerAddress",
                                columnSize: true,
                                value: '-',
                                color: "secondary",
                                fontSize: "sm",
                                pt: 0.3,
                                fontWeight: "normal"
                            }]
                    }]
            }]
    }];
export var vehicalDetails = [{
        type: FormItemTypes.CardComponent,
        name: "",
        columnSize: 12,
        sx: {
            mb: 1
        },
        contentProps: {
            justifyContent: "space-between",
            spacing: 0
        },
        elements: [{
                type: FormItemTypes.Typography,
                name: "RegistrationNumber",
                columnSize: 0,
                value: '-',
                fontWeight: "medium"
            }, {
                type: FormItemTypes.ContainerItem,
                name: "",
                columnSize: 12,
                spacing: 0,
                gap: 1,
                elements: [{
                        type: FormItemTypes.Typography,
                        name: "ModelName",
                        columnSize: 0,
                        value: '-',
                        fontSize: "sm",
                        color: "text.secondary"
                    }, {
                        type: FormItemTypes.Typography,
                        name: "ModelCode",
                        columnSize: 0,
                        value: '-',
                        fontSize: "sm",
                        color: "text.secondary"
                    }]
            }, {
                type: FormItemTypes.CardComponent,
                name: "Vehicle details",
                columnSize: 12,
                sx: {
                    mt: 1,
                    bgcolor: "secondary.50",
                    border: "none"
                },
                contentProps: {
                    spacing: 0
                },
                elements: [{
                        type: FormItemTypes.Typography,
                        name: "EngineNumber",
                        label: "Engine no:",
                        value: '-',
                        containerProps: {
                            display: "inline-flex",
                            justifyContent: "space-between",
                            alignItems: "baseline",
                            gap: 1
                        },
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: "medium",
                            fontSize: "sm"
                        },
                        fontWeight: "medium",
                        fontSize: "sm",
                        columnSize: 12
                    }, {
                        type: FormItemTypes.Typography,
                        name: "ChasisNumber",
                        label: "Chassis no.:",
                        value: '-',
                        containerProps: {
                            display: "inline-flex",
                            justifyContent: "space-between",
                            alignItems: "baseline",
                            gap: 1
                        },
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: "medium",
                            fontSize: "sm"
                        },
                        fontWeight: "medium",
                        fontSize: "sm",
                        columnSize: 12
                    }, {
                        type: FormItemTypes.Typography,
                        name: "DateOfSale",
                        label: "Date of sale:",
                        value: "-",
                        valueGetter: function (formValues, field) {
                            var _field$name, _field$name2;
                            return formValues !== null && formValues !== void 0 && formValues[(_field$name = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name !== void 0 ? _field$name : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name2 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name2 !== void 0 ? _field$name2 : '']).format('DD MMM, YYYY') : '-';
                        },
                        containerProps: {
                            display: "inline-flex",
                            justifyContent: "space-between",
                            alignItems: "baseline",
                            gap: 1
                        },
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: "medium",
                            fontSize: "sm"
                        },
                        fontWeight: "medium",
                        fontSize: "sm",
                        columnSize: 12
                    }]
            }]
    }];
export var basicDetailsAndVehicleDetails = function () {
    var viewMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var showWarrantyDetails = arguments.length > 1 ? arguments[1] : undefined;
    var crud = useAppSelector(function (state) { return state.crud; });
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    return [{
            type: FormItemTypes.CardComponent,
            name: "",
            columnSize: 12,
            sx: {
                border: "1px",
                borderRadius: "12px",
                borderColor: "secondary.200"
            },
            elements: [
                //Basic Details
                {
                    type: FormItemTypes.Typography,
                    name: "",
                    columnSize: true,
                    fontWeight: "strong",
                    children: "Basic details",
                    color: "secondary.900"
                }, {
                    type: FormItemTypes.IconButton,
                    name: "",
                    columnSize: 0,
                    children: /*#__PURE__*/ React.createElement(DropDownIconNew, null),
                    setFormState: function (formValues, currValue) {
                        if (isOpen) {
                            setIsOpen(false);
                        }
                        else {
                            setIsOpen(true);
                        }
                        return {};
                    }
                }, {
                    type: FormItemTypes.CardComponent,
                    name: "",
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: 'basic-details-main-ContainerItem',
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: 'Customer-Details',
                                    spacing: 0,
                                    xs: 12,
                                    sm: 6,
                                    md: viewMode ? 6 : 3,
                                    elements: __spreadArray([{
                                            type: FormItemTypes.ContainerItem,
                                            name: '',
                                            spacing: 0,
                                            columnSize: 12,
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: "",
                                                    children: "Customer details",
                                                    fontSize: "sm",
                                                    fontWeight: "medium",
                                                    color: "text.secondary",
                                                    columnSize: 12
                                                }]
                                        }], (isOpen ? customerDetailsView : [{
                                            type: FormItemTypes.CardComponent,
                                            name: "",
                                            columnSize: 12,
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    gap: 1,
                                                    justifyContent: 'center',
                                                    elements: [{
                                                            type: FormItemTypes.Avatar,
                                                            name: "",
                                                            columnSize: 0,
                                                            sx: {
                                                                height: 25,
                                                                width: 25
                                                            }
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: "CustomerName",
                                                            value: '-',
                                                            columnSize: true,
                                                            fontWeight: "medium",
                                                            valueGetter: function (formValues, field) {
                                                                var customerName = (formValues === null || formValues === void 0 ? void 0 : formValues.CustomerName) || '';
                                                                return customerName.length > 20 ? "".concat(customerName.substring(0, 20), "...") : customerName;
                                                            }
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: "CustomerMobileNumber",
                                                            value: '-',
                                                            columnSize: 0,
                                                            fontSize: "sm",
                                                            fontWeight: "normal",
                                                            color: "secondary.500",
                                                            mt: 0.1
                                                        }]
                                                }]
                                        }]), true)
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: 'Vehicle-Details',
                                    spacing: 0,
                                    xs: 12,
                                    sm: 6,
                                    md: viewMode ? 6 : 3,
                                    elements: __spreadArray([{
                                            type: FormItemTypes.ContainerItem,
                                            name: '',
                                            spacing: 0,
                                            columnSize: 12,
                                            justifyContent: 'space-between',
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: "",
                                                    children: "Vehicle details",
                                                    fontSize: "sm",
                                                    fontWeight: "medium",
                                                    color: "text.secondary",
                                                    columnSize: 0
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: "",
                                                    children: "Vehicle history",
                                                    color: "primary.main",
                                                    fontSize: "sm",
                                                    fontWeight: "medium",
                                                    columnSize: 0
                                                }]
                                        }], (isOpen ? vehicalDetails : [{
                                            type: FormItemTypes.CardComponent,
                                            name: "",
                                            columnSize: 12,
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    gap: 1,
                                                    justifyContent: 'space-between',
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: "RegistrationNumber",
                                                            columnSize: 0,
                                                            value: '-',
                                                            fontWeight: "medium"
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: "ModelName",
                                                            columnSize: 0,
                                                            value: '-',
                                                            fontSize: "sm",
                                                            color: "text.secondary",
                                                            valueGetter: function (formValues) { return "".concat((formValues === null || formValues === void 0 ? void 0 : formValues.ModelName) || '', " (").concat((formValues === null || formValues === void 0 ? void 0 : formValues.ModelCode) || '', ")"); }
                                                        }]
                                                }]
                                        }]), true)
                                }, !viewMode ? {
                                    type: FormItemTypes.ContainerItem,
                                    name: 'Job-card-details',
                                    spacing: 0,
                                    xs: 12,
                                    sm: 6,
                                    md: 3,
                                    elements: [{
                                            type: FormItemTypes.ContainerItem,
                                            name: '',
                                            spacing: 0,
                                            columnSize: 12,
                                            justifyContent: 'space-between',
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: "",
                                                    children: "Job card details",
                                                    fontSize: "sm",
                                                    fontWeight: "medium",
                                                    color: "text.secondary",
                                                    columnSize: 0
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: "",
                                                    children: "Warranty part details",
                                                    color: "primary.main",
                                                    fontSize: "sm",
                                                    fontWeight: "medium",
                                                    sx: {
                                                        cursor: "pointer"
                                                    },
                                                    columnSize: 0,
                                                    onClick: function () {
                                                        showWarrantyDetails && showWarrantyDetails();
                                                    }
                                                }]
                                        }, isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: "",
                                            columnSize: 12,
                                            sx: {
                                                mt: 1
                                            },
                                            contentProps: {
                                                justifyContent: "space-between",
                                                spacing: 0
                                            },
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: "JobCardNumber",
                                                    columnSize: 12,
                                                    value: '-',
                                                    fontWeight: "medium"
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: "DispatchDate",
                                                    columnSize: 12,
                                                    value: '-',
                                                    valueGetter: function (formValues, field) {
                                                        var _field$name3, _field$name4;
                                                        return formValues !== null && formValues !== void 0 && formValues[(_field$name3 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name3 !== void 0 ? _field$name3 : ""] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name4 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name4 !== void 0 ? _field$name4 : ""]).format("DD MMM, YYYY") : "-";
                                                    },
                                                    fontSize: "sm",
                                                    color: "text.secondary"
                                                }, {
                                                    type: FormItemTypes.CardComponent,
                                                    name: "Vehicle details",
                                                    columnSize: 12,
                                                    sx: {
                                                        mt: 1,
                                                        bgcolor: "secondary.50",
                                                        border: "none"
                                                    },
                                                    contentProps: {
                                                        spacing: 0
                                                    },
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: "EstimateDeliveryDateTime",
                                                            label: "Est delivery:",
                                                            value: '-',
                                                            containerProps: {
                                                                display: "inline-flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "baseline",
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: "medium",
                                                                fontSize: "sm"
                                                            },
                                                            fontWeight: "medium",
                                                            fontSize: "sm",
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: "ServiceAdvisor",
                                                            label: "Service adviser:",
                                                            value: '-',
                                                            containerProps: {
                                                                display: "inline-flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "baseline",
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: "medium",
                                                                fontSize: "sm"
                                                            },
                                                            fontWeight: "medium",
                                                            fontSize: "sm",
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: "Campaign",
                                                            label: "Campaign :",
                                                            value: "-",
                                                            valueGetter: function (formValues, field) {
                                                                var _field$name5, _field$name6;
                                                                return formValues !== null && formValues !== void 0 && formValues[(_field$name5 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name5 !== void 0 ? _field$name5 : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name6 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name6 !== void 0 ? _field$name6 : '']).format('DD MMM, YYYY') : '-';
                                                            },
                                                            containerProps: {
                                                                display: "inline-flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "baseline",
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: "medium",
                                                                fontSize: "sm"
                                                            },
                                                            fontWeight: "medium",
                                                            fontSize: "sm",
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: "DelayReason",
                                                            label: "Delay reason:",
                                                            value: "-",
                                                            valueGetter: function (formValues, field) {
                                                                var _field$name7, _field$name8;
                                                                return formValues !== null && formValues !== void 0 && formValues[(_field$name7 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name7 !== void 0 ? _field$name7 : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name8 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name8 !== void 0 ? _field$name8 : '']).format('DD MMM, YYYY') : '-';
                                                            },
                                                            containerProps: {
                                                                display: "inline-flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "baseline",
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: "medium",
                                                                fontSize: "sm"
                                                            },
                                                            fontWeight: "medium",
                                                            fontSize: "sm",
                                                            columnSize: 12
                                                        }]
                                                }]
                                        } : {
                                            type: FormItemTypes.CardComponent,
                                            name: "",
                                            columnSize: 12,
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    gap: 1,
                                                    justifyContent: 'center',
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: "JobCardNumber",
                                                            columnSize: true,
                                                            value: '-',
                                                            fontWeight: "medium",
                                                            valueGetter: function (formValues, field) {
                                                                var JobCardNumber = (formValues === null || formValues === void 0 ? void 0 : formValues.JobCardNumber) || '';
                                                                return JobCardNumber.length > 25 ? "".concat(JobCardNumber.substring(0, 25), "...") : JobCardNumber;
                                                            }
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: "DispatchDate",
                                                            columnSize: 0,
                                                            value: '-',
                                                            valueGetter: function (formValues, field) {
                                                                var _field$name9, _field$name10;
                                                                return formValues !== null && formValues !== void 0 && formValues[(_field$name9 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name9 !== void 0 ? _field$name9 : ""] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name10 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name10 !== void 0 ? _field$name10 : ""]).format("DD MMM, YYYY") : "-";
                                                            },
                                                            fontSize: "sm",
                                                            color: "text.secondary"
                                                        }]
                                                }]
                                        }]
                                } : null]
                        }]
                }
            ]
        }];
};
